import { getRequest } from '../../methods';

const getLabels = () => getRequest('labels');

const labels = {
  getLabels,
};

export default labels;
